<template>
  <div class="wrapper">
    <CRow class="mt-3">
      <CCol  sm="12" lg="4">
        <CCard>
          <CCardHeader> 
            <b> Article Form </b> 
          </CCardHeader>
            <CCardBody>
              <CRow>
                <CCol sm="12" >
                <strong>  Title  </strong>
                <b-input
                v-model="form.title"
                placeholder="Title"
                id="feedback-user"
                class="mb-1"
                :class="errors.title ? 'is-invalid' : ''"
              >
              </b-input>
              <b-form-invalid-feedback >
                Your title must be filled
              </b-form-invalid-feedback> 
                </CCol>
              </CRow>
              <CRow class="mt-3">
                <CCol >
                  <strong> Author  </strong>
                  <b-input
                v-model="form.author"
                placeholder="Author"
                id="feedback-user"
                class="mb-1"
                :class="errors.author ? 'is-invalid' : ''"
              >
              </b-input>
              <b-form-invalid-feedback >
                Your author must be filled
              </b-form-invalid-feedback>  
                </CCol>
            </CRow>
            <CRow class="mt-3">
              <CCol>
                <strong>  Date Publish </strong>
                <CInput type="date" v-model="form.publish_date"></CInput>
                <!-- <datetime  format="DD-MM-YYYY" width="100%" v-model="form.publish_date"></datetime> -->
              </CCol>
            </CRow>  
            <CRow class="mt-3">
              <CCol>
                <strong> Category </strong>
                <b-form-select v-model="form.category_id"  :class="errors.category_id ? 'is-invalid' : ''" id="feedback-user"  :options="options"></b-form-select>
                <b-form-invalid-feedback >
                Your category must be select 
                </b-form-invalid-feedback>
              </CCol>
            </CRow>
            <hr>
            <strong >  Background Image </strong>
            <CRow class="mb-3">
              <CCol >
                <p style="color:blue;">Resolusi gambar sebaiknya 2:1 | contoh 600x300 / 1568x784</p>
                 <img v-if="btn_create" v-bind:src="getPhoto(form.bg_image)" width="200px" height="130px">
                <img v-bind:src="form.bg_image" style="width:200px"/>
                <b-form-file v-if="btn_create" v-model="form.bg_image"  plain></b-form-file>
                <CButton  class="ml-3" v-if="btn_update" type="button" @click="openModalPhotoBGImage(form.id)"  variant="outline" color="info">Change Image</CButton>
              </CCol>
            </CRow>
            <CRow class="mt-3">
              <CCol sm="12">
                <b-form-checkbox 
                id="checkbox-1"
                v-model="form.is_publish"
                name="checkbox-1"
                value="1"
                unchecked-value="0"
                >
                Checked this box if you want to <b>PUBLISH </b> this Article.
                </b-form-checkbox>
              </CCol>
            </CRow>  
            </CCardBody>
        </CCard>
      </CCol>
      <CCol sm="12" lg="8">
        <CCard>
          <CCardBody>
            <CRow class="mt-3" >
              <CCol >
              <label> Rich Text </label>
              <editor id="editor" v-model="form.rich_text" api-key="hq3wl53w9617r84m5cjgkm5h18xckn5mtfl0bvlkkytchrv8" :init="init">{{ form.rich_text }}</editor>
              </CCol>
            </CRow>   
          </CCardBody>
        </CCard>
        <CButton v-if="btn_create " block type="submit" v-on:click.prevent="create()"   color="info"><b>Create </b></CButton>
        <CButton v-if="btn_update" block type="submit" v-on:click.prevent="update(form.id)"   color="info">Update</CButton>
      </CCol>
    </CRow>  
    <br><br>
    <alertmodal></alertmodal>
    <modalphotobg></modalphotobg>
    <!-- <pre>{{ $data | json }}</pre> -->
  </div>
</template>

<script>
import axios from 'axios'
import datetime from 'vuejs-datetimepicker';

import { BTooltip } from 'bootstrap-vue'
Vue.component('b-tooltip', BTooltip)

import EventBus from '@/eventBus';
import alertmodal from '@/views/alert/modal.vue';

import article from '@/services/article';
import articlecategory from '@/services/articlecategory'

//import tinymce from "vue-tinymce-editor";
import Editor from '@tinymce/tinymce-vue';

import modalphotobg from './article_modal_photo_bgimage.vue';

import Vue from 'vue'
import moment from 'moment'



export default {
name: 'articleform',
  components: {
    datetime,
    alertmodal,
    'editor': Editor, 
    modalphotobg,
  },
  data () {
    return {
      errors: {},
      errors_from_backend: [],
      loading: false,
        form:{
            id: '',
            title: '',
            author:'',
            category_id:'',
            publish_date:'',
            bg_image:'',
            is_publish:'0',
            rich_text:''
        },
        options: [  
        ],
        btn_create: 0,
        btn_update: 0,
        init: {
            height: 500,
            init_instance_callback : function(editor) {
                var freeTiny = document.querySelector('.tox .tox-notification--in');
            freeTiny.style.display = 'none';
            },
            plugins: [
            'advlist autolink lists link image charmap',
            'searchreplace visualblocks',
            'insertdatetime table paste code wordcount',
            'autosave',
            ],
            content_style: "body { background-color: #32323D; }",
            toolbar:
            'restoredraft | undo redo | formatselect | bold italic forecolor | \
            alignleft aligncenter alignright alignjustify | \
            bullist numlist outdent indent | removeformat',
            autosave_interval: '1s',
            // autosave_prefix: 'tinymce-autosave-{path}{query}-{id}-',
            images_upload_credentials: true,
            //images_upload_url: 'http://localhost:3300/imageupload/postAcceptor.php',
            images_upload_handler: function (blobInfo, success, failure) {
            var xhr, formData;
            xhr = new XMLHttpRequest();
            xhr.withCredentials = false;
            //xhr.open('POST', 'http://localhost:8005/api/testupload');
            xhr.open('POST', process.env.VUE_APP_URL +'/upload_image_tinymce');
            xhr.onload = function() {
                var json;

                if (xhr.status != 200) {
                failure('HTTP Error: ' + xhr.status);
                return;
                }
                json = JSON.parse(xhr.responseText);

                if (!json || typeof json.location != 'string') {
                failure('Invalid JSON: ' + xhr.responseText);
                return;
                }
                success(json.location);
            };
            formData = new FormData();
            formData.append('file', blobInfo.blob(), blobInfo.filename());
            xhr.send(formData);
            }
            
        },   
        
      
    }
  },
   computed: {
   },
  mounted(){
    this.loadData()
    EventBus.$on('TABLE_UPDATE_DETAIL_ARTICLE', (data) => {
      if(data){
          this.loadData();
      }
    });
  },

  beforeDestroy() {
    // removing eventBus listener
    EventBus.$off('TABLE_UPDATE_ARTICLE')
  },
  
  created () {
     articlecategory.getArticleCategory()
      .then(res => {
        for (let i=0; i <= res.data.length; i++){
          //alert
          this.options.push({text:res.data[i].title, value:res.data[i].id})
        }
      }).catch((er) =>{
    })   
  },
  methods: {
      loadData(){
        if(this.$route.query.id){
            this.btn_update = 1;
            article.getArticlebyID(this.$route.query.id)
            .then(res => {
                this.form.id = res.data.id;
                this.form.title = res.data.title;
                this.form.author = res.data.author;
                this.form.publish_date = res.data.publish_date;
                this.form.rich_text = res.data.rich_text;
                this.form.category_id = res.data.category_id;
                this.form.bg_image = res.data.bg_image;
                this.form.is_publish = res.data.is_publish;
                //this.form.mobile_setting = !empty(res.data.mobile_setting) ? JSON.parse(res.data.mobile_setting) : '';
            }).catch ((err) => {
            var params = {title: 'Error', mode:'danger', data:err.response.data.message}
            EventBus.$emit('OPEN_MODAL_ALERT', params)
            })
        }else{
            this.btn_create = 1;
        }
      },

    create(){
      let formData = new FormData();      
      if( this.form.publish_date != '' ){this.form.publish_date  = moment(this.form.publish_date).format ('DD/MM/YYYY')} 
      formData.append('title', this.form.title );
      formData.append('author', this.form.author );
      formData.append('category_id', this.form.category_id );
      formData.append('publish_date', this.form.publish_date );
      formData.append('bg_image', this.form.bg_image );
      formData.append('is_publish', this.form.is_publish );
      formData.append('rich_text', this.form.rich_text );
      this.loading = true;
      if (this.check_form()) {
      article.createArticle(formData)
      .then(res => {
        var params = {title: 'Success', mode:'success', data:res.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
        setTimeout(() => {  this.$router.push({name:'Article Table'}) }, 1500);
      }).catch((err) => {
        this.loading = false;
        alert(err.response.data.message);
        //alert(JSON.stringify(err.response.data.errors));
        if (err.response.data.errors != null) {
            this.errors_from_backend = err.response.data.errors;
            console.log(JSON.stringify(err.response.data.errors));
        }
          });
      }else{
      this.loading = false;
      }
    },
    update(id){
      let formData = new FormData();  
      if( this.form.publish_date != null ){this.form.publish_date  = moment(this.form.publish_date).format ('DD/MM/YYYY')} 
      formData.append('title', this.form.title );
      formData.append('author', this.form.author );
      formData.append('category_id', this.form.category_id );
      formData.append('publish_date', this.form.publish_date );
      formData.append('bg_image', this.form.bg_image );
      formData.append('is_publish', this.form.is_publish );
      formData.append('rich_text', this.form.rich_text );
      this.show = false;
      article.updateArticle(id, this.form)
      .then(res => {
        EventBus.$emit('TABLE_UPDATE_DETAIL_ARTICLE', true)
        var params = {title: 'Success', mode:'success', data:res.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)     
      }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.response.data.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
      })
    },
    openModalPhotoBGImage(id){
        var params = {title: 'Update BG Image', mode:'edit', data:id}
        EventBus.$emit('OPEN_MODAL_BGIMAGE_ARTICLE', params)
        console.log('load modal photo')      
    },
      getPhoto(data){
      console.log('get - photo')
        if (data){
            return axios.defaults.baseURL + '/getfile/' + data.path + '/' + data.filename
        }else{
            return axios.defaults.baseURL + '/getfile/memberphoto/no_photo.jpg'
        } 
    }, 
    check_form: function(e) {
         this.errors = {};
         if (!this.form.title) {
            this.errors["title"] = "1";
         }
         if (!this.form.author) {
            this.errors["author"] = "1";
         }
         if (!this.form.category_id) {
            this.errors["category_id"] = "1";
         }
        

         if (
            this.form.title &&
            this.form.author &&
            this.form.category_id 
         ) {
            return true;
         } else {
            return false;
         }
      },
  }
}

</script>
<style>

h1 {
	height: 120px;
	line-height: 120px;
	text-align: center;
}
.vc-chrome {
	position: absolute;
	top: 35px;
	right: 0;
	z-index: 9;
}
.current-color {
	display: inline-block;
	width: 16px;
	height: 16px;
	background-color: #000;
	cursor: pointer;
}
.footer {
	margin-top: 20px;
	text-align: center;
}
</style>